import React from 'react'

export function AviFollowButton({children}: {children: React.ReactNode}) {
  return children
}
